import { render } from "./PrivateMainView.vue?vue&type=template&id=9ca14f12"
import script from "./PrivateMainView.vue?vue&type=script&lang=js"
export * from "./PrivateMainView.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__